import { Injectable } from '@angular/core';
import { BaseProvider } from '../../../../shared/providers/base-provider';
import { FlightNotifier } from './flight-notifier';
import { FlightState } from './flight-state';
import { FlightService } from './flight-service';

@Injectable()
export class FlightProvider extends BaseProvider<FlightNotifier, FlightState> {
  constructor() {
    super(FlightNotifier);
    this.trackSessionReset(() => this.notifier.reset());
  }
}